"use strict";

exports.__esModule = true;
exports.createModalData = exports.DEFAULT_MAX_SERVICES_CONSTRAINT = void 0;
var _types = require("../../types");
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
const DEFAULT_MAX_SERVICES_CONSTRAINT = exports.DEFAULT_MAX_SERVICES_CONSTRAINT = 5;
const createModalData = ({
  regionalSettingsLocale,
  service,
  preselectedValues,
  basket,
  maxServices = DEFAULT_MAX_SERVICES_CONSTRAINT,
  bookingsSettings,
  resourceFromUrl
}) => {
  return {
    services: {
      status: _types.AsyncComponentDataStatus.LOADING
    },
    inView: {
      service,
      serviceOptionsAndVariants: {
        status: (0, _bookingsCalendarCatalogViewerMapper.isServiceWithVariedPrice)(service) && (!basket || maxServices === 1) ? _types.AsyncComponentDataStatus.LOADING : _types.AsyncComponentDataStatus.IDLE,
        data: undefined
      },
      addOnsGroups: {
        status: (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service) ? _types.AsyncComponentDataStatus.LOADING : _types.AsyncComponentDataStatus.IDLE,
        data: undefined
      },
      preselectedValues
    },
    regionalSettingsLocale,
    basket,
    constrains: {
      maxServices
    },
    bookingsSettings,
    resourceFromUrl
  };
};
exports.createModalData = createModalData;
//# sourceMappingURL=createModalData.js.map